import React from 'react';
import '../../styles/pages/HomePage.css';
import { setViewportHeight } from '../../utils/viewport';

const HomePage = ({ setActivePage }) => {
  // Add effect to control body overflow
  React.useEffect(() => {
    // Prevent scrolling on homepage
    document.body.style.height = `${window.innerHeight}px`;
    document.body.style.overflow = 'hidden';
    
    // Force height recalculation - explicitly pass false to ensure no scroll
    setViewportHeight(false);
    
    // Cleanup function to restore scrolling when navigating away
    return () => {
      document.body.style.height = '';
      document.body.style.overflow = '';
    };
  }, []);

  // Add effect for handling input focus (when keyboard appears)
  React.useEffect(() => {
    const handleInputFocus = () => {
      // When an input is focused, recalculate viewport
      setTimeout(setViewportHeight, 100);
    };

    // Add event listeners for all inputs
    const inputs = document.querySelectorAll('input');
    inputs.forEach(input => {
      input.addEventListener('focus', handleInputFocus);
    });

    return () => {
      // Clean up event listeners
      inputs.forEach(input => {
        input.removeEventListener('focus', handleInputFocus);
      });
    };
  }, []);

  return (
    <div className="homepage-container">
      <div className="background-pattern"></div>
      {/* Hero Section - Now full screen with oversized elements */}
      <div className="hero-section flex-grow flex items-center relative overflow-hidden">
        <div className="container mx-auto px-4 relative">
          {/* Desktop layout with flex - removed flex-container class */}
          <div className="desktop-layout flex flex-col md:flex-row items-center justify-between relative">
            <div className="w-full md:w-1/2 mb-8 md:mb-0 animate-on-scroll">
              <div className="hero-heading-container">
                <img 
                  src="/kimchi-logo.svg" 
                  alt="Mr. Won's Kick-Ass Kimchi" 
                  className="kimchi-title-svg"
                />
              </div>
            </div>
            
            <div className="w-full md:w-1/2 flex justify-center animate-on-scroll">
              <div className="hero-image-container relative">
                {/* Separate blue circle as background */}
                <div className="blue-circle"></div>
                
                {/* Glow effect separated */}
                <div className="glow-circle"></div>
                
                {/* Won kicking image on top */}
                <div className="won-kicking-container">
                  <img 
                    src="/won-kick.svg" 
                    alt="Won Kicking" 
                    className="won-kicking-image"
                  />
                </div>
              </div>
            </div>
          </div>
          
          {/* Mobile Layout with absolute positioning */}
          <div className="mobile-layout">
            {/* Circles container */}
            <div className="mobile-circles-container">
              {/* Blue circle at the back */}
              <div className="mobile-blue-circle"></div>
              
              {/* Glow effect */}
              <div className="mobile-glow-circle"></div>
            </div>
            
            {/* Title SVG in the middle */}
            <img 
              src="/kimchi-logo.svg" 
              alt="Mr. Won's Kick-Ass Kimchi" 
              className="mobile-kimchi-title"
            />
            
            {/* Kicking image on top */}
            <div className="mobile-kicking-container">
              <img 
                src="/won-kick.svg" 
                alt="Won Kicking" 
                className="mobile-kicking-image"
              />
            </div>
          </div>
          
          {/* Hero content box positioned at bottom center - Only visible on desktop */}
          <div className="hero-content-box desktop-only">
            <div className="hero-content-grid">
              <div className="hero-content-main">
                <div className="inverted-text-block">
                  <p className="font-medium headline-text">
                  <span className="text-2xl">FERMENTED WITH FURY TO KICKSTART YOUR GUT!</span>
                  </p>
                </div>
                
                <button
                  className="shop-now-btn text-2xl"
                  onClick={() => setActivePage('shop')}
                >
                  SHOP NOW
                </button>
              </div>
              
              <div className="hero-content-newsletter">
                <h3 className="text-2xl font-bold mb-3 headline-text">JOIN THE KIMCHI DOJO</h3>
                <div className="newsletter-form-compact">
                  <form 
                    action="https://app.kit.com/forms/7913185/subscriptions" 
                    className="seva-form formkit-form"
                    method="post" 
                    data-sv-form="7913185" 
                    data-uid="42bbb18512" 
                    data-format="inline"
                  >
                    <div className="formkit-fields" data-stacked="false">
                      <div className="formkit-field">
                        <input 
                          className="newsletter-input-compact formkit-input" 
                          name="email_address" 
                          placeholder="YOUR EMAIL" 
                          required 
                          type="email"
                        />
                      </div>
                      <button 
                        data-element="submit" 
                        className="newsletter-button-compact text-2xl formkit-submit"
                      >
                        <p>SIGN UP</p>
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
          
          {/* Mobile-only simple bottom box */}
          <div className="mobile-hero-box">
            <div className="mobile-hero-text">FERMENTED WITH FURY</div>
            <div className="mobile-hero-actions">
              <div className="mobile-email-signup">
                <form 
                  action="https://app.kit.com/forms/7913185/subscriptions" 
                  className="seva-form formkit-form"
                  method="post" 
                  data-sv-form="7913185" 
                  data-uid="42bbb18512" 
                  data-format="inline"
                >
                  <input 
                    className="mobile-email-input" 
                    name="email_address" 
                    placeholder="YOUR EMAIL" 
                    required 
                    type="email"
                  />
                  <button 
                    data-element="submit" 
                    className="mobile-join-btn"
                  >
                    JOIN THE DOJO
                  </button>
                </form>
              </div>
              <button 
                className="mobile-shop-btn"
                onClick={() => setActivePage('shop')}
              >
                SHOP NOW
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomePage; 